const removeTrailingSlash = (url) => {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }

    if (url.includes('?')) {
        const path = url.split('?')[0];
        if (path.endsWith('/')) {
            url = path.slice(0, -1) + url.slice(path.length);
        }
    }

    return url;
};

export default () => {
    const url = removeTrailingSlash(`${window.location.origin}${window.location.pathname}`);

    let isActive = false;

    document.body.querySelectorAll('.sidebar-menu .treeview').forEach((item) => {
        item.querySelector('.active') && item.querySelector('.active').classList.remove('active');
        item.classList.remove('active', 'menu-open');

        item.getElementsByTagName('a').forEach((link) => {
            const href = removeTrailingSlash(link.getAttribute('href'));

            link.closest('li') && link.closest('li').classList.remove('active');

            if (url.includes(href)) {
                if (url === href) {
                    link.closest('li') && link.closest('li').classList.add('active');
                }

                if (!isActive && link.closest('.treeview-menu') && link.closest('li.treeview:not(.active)')) {
                    isActive = true;
                    link.closest('li.treeview').classList.add('active', 'menu-open');
                }
            }
        });
    });
};
